import { getThumbSize } from "./auth-service-tools1145.js";
import { linearScale } from "./auth-service-tools1146.js";

function getScrollPositionFromPointer(pointerPos, pointerOffset, sizes) {
  let dir = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ltr";
  const thumbSizePx = getThumbSize(sizes);
  const thumbCenter = thumbSizePx / 2;
  const offset = pointerOffset || thumbCenter;
  const thumbOffsetFromEnd = thumbSizePx - offset;
  const minPointerPos = sizes.scrollbar.paddingStart + offset;
  const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
  const maxScrollPos = sizes.content - sizes.viewport;
  const scrollRange = dir === "ltr" ? [0, maxScrollPos] : [maxScrollPos * -1, 0];
  const interpolate = linearScale([minPointerPos, maxPointerPos], scrollRange);
  return interpolate(pointerPos);
}

export { getScrollPositionFromPointer };